export default "__VITE_ASSET__DWKMfOqA__"